import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Text } from '@rsos/base-components';
import { setSelectedTab } from '@rsos/reduxDataStore/src/features/eventPane/eventPaneSlice';
import {
  StyledEventPaneTabs,
  ButtonGroup,
  TabContent,
  PillButton,
} from './EventPaneTabs.styles';

const ID_PREFIX = 'event-pane';

export const Tab = ({ Label, id, children, disabled = false }) => {
  return { Label, id: `${ID_PREFIX}-${id}`, content: children, disabled };
};

export const TabLabel = ({ Icon, text, height = 14 }) => {
  return (
    <Box direction="row" horizontal justify="center" align="center">
      <Icon height={`${height}px`} />
      <Text fontWeight="bold" ml="3px">
        {text}
      </Text>
    </Box>
  );
};

export const TabSwitcher = ({ children }) => {
  const dispatch = useDispatch();
  const selectedTab = useSelector(state => state?.eventPane?.selectedTab);
  const tabContentRef = useRef(null);

  const renderTabs = () => {
    return React.Children.map(children, child => {
      const { Label, id, disabled, hidden } = child.props;
      return (
        <PillButton
          key={id}
          onClick={() => !disabled && dispatch(setSelectedTab(id))}
          disabled={disabled}
          hidden={hidden}
          active={selectedTab === id}
          noMargin
        >
          {Label || id}
        </PillButton>
      );
    });
  };

  const renderActiveTabContent = () => {
    const activeChild = React.Children.toArray(children).find(
      child => child.props.id === selectedTab,
    );
    return activeChild ? activeChild.props.children : null;
  };

  return (
    <StyledEventPaneTabs>
      <ButtonGroup id={`${ID_PREFIX}-tabs`}>{renderTabs()}</ButtonGroup>
      <TabContent id={`${ID_PREFIX}-tab-content`} ref={tabContentRef}>
        {renderActiveTabContent()}
      </TabContent>
    </StyledEventPaneTabs>
  );
};
